import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="about-brief" className="py-16 md:py-20 bg-background-50">
      <div className="site-container px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-primary-50 text-primary-700 text-xs font-semibold rounded-full mb-3">
            核心优势
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            为什么选择南宫集团
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            以技术创新为核心驱动力，为用户提供安全、可靠、高效的全方位服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuresData.map((feature, index) => (
            <div
              key={index}
              className="group bg-background-50 border border-background-200 rounded-xl p-6 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}